/* ==========================================================================
   LT INTERNATIONAL — V9 LIGHT LUXURY MASTER PORTAL CONTROLLER
   ========================================================================== */

document.addEventListener("DOMContentLoaded", () => {
  initLoader();
  initBackgroundCells();
  initThemeToggle();
  initCursorGlow();
  initPillarsHub();
  init3DCardCarousel();
  init3DTiltEffect();
  initMagneticButtons();
});

/**
 * 1. Cinematic Page Loader Screen with science tagline and running percentage counter
 */
function initLoader() {
  const loader = document.getElementById("brand-loader");
  const percentText = document.getElementById("loader-percentage");
  const barFill = document.getElementById("loader-progress-bar");
  if (!loader) return;
  
  let progress = 0;
  const duration = 1600; // 1.6s
  const intervalTime = 16;
  const steps = duration / intervalTime;
  const increment = 100 / steps;
  
  const timer = setInterval(() => {
    progress += increment;
    if (progress >= 100) {
      progress = 100;
      clearInterval(timer);
      
      if (barFill) barFill.style.width = '100%';
      if (percentText) percentText.textContent = '100%';
      
      setTimeout(() => {
        loader.classList.add("fade-out");
      }, 300);
    } else {
      const roundedProgress = Math.floor(progress);
      if (barFill) barFill.style.width = `${roundedProgress}%`;
      if (percentText) percentText.textContent = `${roundedProgress}%`;
    }
  }, intervalTime);
}

/**
 * 2. Floating molecular background particles
 */
function initBackgroundCells() {
  const canvas = document.querySelector(".molecular-bg-canvas");
  if (!canvas) return;

  const particleCount = 14;
  for (let i = 0; i < particleCount; i++) {
    const el = document.createElement("div");
    el.style.position = "absolute";
    el.style.borderRadius = "50%";
    
    // Mix sizes and colors matching resveratrol grape/algae theme
    const size = Math.random() * 12 + 4;
    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    
    const isPurple = Math.random() > 0.5;
    el.style.background = isPurple ? "rgba(89, 35, 62, 0.08)" : "rgba(197, 168, 128, 0.08)";
    el.style.filter = "blur(1px)";
    
    // Position randomly
    el.style.left = `${Math.random() * 100}%`;
    el.style.top = `${Math.random() * 100}%`;
    
    // Add custom float speeds
    const duration = Math.random() * 18 + 12;
    const delay = Math.random() * -10;
    
    el.style.animation = `driftParticle ${duration}s infinite linear`;
    el.style.animationDelay = `${delay}s`;
    
    canvas.appendChild(el);
  }

  // Inject drift keyframes dynamically
  const style = document.createElement("style");
  style.textContent = `
    @keyframes driftParticle {
      0% { transform: translate(0, 0) rotate(0deg); opacity: 0; }
      10% { opacity: 0.6; }
      90% { opacity: 0.6; }
      100% { transform: translate(${(Math.random() * 160 - 80)}px, -${(Math.random() * 200 + 100)}px) rotate(360deg); opacity: 0; }
    }
  `;
  document.head.appendChild(style);
}

/**
 * 3. Handles B2C (Consumer) / B2B (Distributor Partner) View switching
 */
function initThemeToggle() {
  const toggleBtn = document.getElementById("view-toggle");
  if (!toggleBtn) return;

  const b2cLabel = document.querySelector(".view-switch-label.b2c-label");
  const b2bLabel = document.querySelector(".view-switch-label.b2b-label");

  // Sync view state between pages via localStorage
  const currentView = localStorage.getItem("view") || "b2c";
  document.documentElement.setAttribute("data-view", currentView);
  updateViewUI(currentView);

  toggleBtn.addEventListener("click", () => {
    let view = document.documentElement.getAttribute("data-view");
    let newView = view === "b2b" ? "b2c" : "b2b";
    
    document.documentElement.setAttribute("data-view", newView);
    localStorage.setItem("view", newView);
    updateViewUI(newView);
    
    // Trigger custom event so product.html configurator can sync
    const event = new CustomEvent("viewChanged", { detail: { view: newView } });
    document.dispatchEvent(event);
  });

  function updateViewUI(view) {
    if (view === "b2b") {
      if (b2cLabel) b2cLabel.classList.remove("active");
      if (b2bLabel) b2bLabel.classList.add("active");
    } else {
      if (b2cLabel) b2cLabel.classList.add("active");
      if (b2bLabel) b2bLabel.classList.remove("active");
    }
    
    updateHomepagePricingText(view);
  }

  function updateHomepagePricingText(view) {
    // Dynamic price swap on index.html showcase cards
    const cards = document.querySelectorAll(".premium-product-card");
    if (cards.length < 3) return;

    if (view === "b2b") {
      // Card 1
      const meta1 = cards[0].querySelector(".premium-card-meta");
      if (meta1) {
        meta1.querySelector(".premium-card-name").textContent = "CRIII Pioneer Member Program";
        const subtitle = meta1.querySelector(".premium-card-subtitle");
        if (subtitle) {
          subtitle.style.color = "var(--accent-gold)";
          subtitle.textContent = "RM6,000 — 12x 600 Tabs + 12x 300 Tabs FREE";
        }
      }
      const footer1 = cards[0].querySelector(".premium-card-cta");
      if (footer1) footer1.textContent = "Secure Pioneer Enrollment";

      // Card 2
      const meta2 = cards[1].querySelector(".premium-card-meta");
      if (meta2) {
        meta2.querySelector(".premium-card-name").textContent = "CRIII Elite Business Partner";
        const subtitle = meta2.querySelector(".premium-card-subtitle");
        if (subtitle) {
          subtitle.style.color = "var(--accent-gold)";
          subtitle.textContent = "RM10,000 — 24x Bottles + Liquid Extract FREE";
        }
      }
      const footer2 = cards[1].querySelector(".premium-card-cta");
      if (footer2) footer2.textContent = "Secure Business Partner Plan";

      // Card 3
      const meta3 = cards[2].querySelector(".premium-card-meta");
      if (meta3) {
        meta3.querySelector(".premium-card-name").textContent = "Corporate Wholesale Sweeping Plan";
        const subtitle = meta3.querySelector(".premium-card-subtitle");
        if (subtitle) {
          subtitle.style.color = "var(--forest-green)";
          subtitle.textContent = "Custom Volume — Minimum 50 Bottles Calibration";
        }
      }
      const footer3 = cards[2].querySelector(".premium-card-cta");
      if (footer3) {
        footer3.textContent = "Request Corporate Quote";
        footer3.style.color = "var(--accent-gold)";
      }
      const arrow3 = cards[2].querySelector(".premium-card-arrow");
      if (arrow3) {
        arrow3.style.background = "var(--accent-gold)";
        arrow3.style.borderColor = "var(--accent-gold)";
      }
    } else {
      // Retail view
      // Card 1
      const meta1 = cards[0].querySelector(".premium-card-meta");
      if (meta1) {
        meta1.querySelector(".premium-card-name").textContent = "CRIII Original 600 Tabs";
        const subtitle = meta1.querySelector(".premium-card-subtitle");
        if (subtitle) {
          subtitle.style.color = "var(--brand-purple)";
          subtitle.textContent = "RM498 — Flagship Dosing Plan";
        }
      }
      const footer1 = cards[0].querySelector(".premium-card-cta");
      if (footer1) footer1.textContent = "Configure Dosing & Subscription";

      // Card 2
      const meta2 = cards[1].querySelector(".premium-card-meta");
      if (meta2) {
        meta2.querySelector(".premium-card-name").textContent = "CRIII Original 300 Tabs";
        const subtitle = meta2.querySelector(".premium-card-subtitle");
        if (subtitle) {
          subtitle.style.color = "var(--brand-purple)";
          subtitle.textContent = "RM265 — Baseline Protection";
        }
      }
      const footer2 = cards[1].querySelector(".premium-card-cta");
      if (footer2) footer2.textContent = "Configure Dosing & Subscription";

      // Card 3
      const meta3 = cards[2].querySelector(".premium-card-meta");
      if (meta3) {
        meta3.querySelector(".premium-card-name").textContent = "Cryptomonadales Extract Liquid";
        const subtitle = meta3.querySelector(".premium-card-subtitle");
        if (subtitle) {
          subtitle.style.color = "var(--accent-gold)";
          subtitle.textContent = "RM2,499 — Ultimate Cellular Infusion";
        }
      }
      const footer3 = cards[2].querySelector(".premium-card-cta");
      if (footer3) {
        footer3.textContent = "Configure Liquid Dosing & Sub";
        footer3.style.color = "var(--accent-gold)";
      }
      const arrow3 = cards[2].querySelector(".premium-card-arrow");
      if (arrow3) {
        arrow3.style.background = "var(--accent-gold)";
        arrow3.style.borderColor = "var(--accent-gold)";
      }
    }
  }
}

/**
 * 4. Ambient Cursor glow light tracer
 */
function initCursorGlow() {
  const glow = document.getElementById("cursor-glow");
  if (!glow) return;

  document.addEventListener("mousemove", (e) => {
    // Smoothen positioning using requestAnimationFrame
    requestAnimationFrame(() => {
      glow.style.left = `${e.clientX}px`;
      glow.style.top = `${e.clientY}px`;
    });
  });
}

/**
 * 5. 5 Health Pillars Hub tab swapping
 */
const pillarData = {
  cancer: {
    title: "Cellular <strong>Recovery</strong> 🧬",
    desc: "Targeting damaged biological structures by triggering targeted phagocytosis. Chlorella's unique <em>bio-glycoproteins</em> stimulate lymphocyte proliferation to sweep out mutated cancer-prone cells and rapidly reconstruct tissue frameworks.",
    graphic: "./cancer_cell_cutout.png",
    stat1: "94.2%",
    stat1Label: "Cell Recovery Rate",
    stat2: "4.8x",
    stat2Label: "Immune sweep factor"
  },
  heart: {
    title: "Cardiovascular <strong>Relief</strong> 🫀",
    desc: "Unclogging biological pathways through high-density pigment structures. Clean <em>vascular lining optimization</em> stimulates nitric oxide synthase, dilating blood vessels and restoring arterial elasticity for maximum oxygen delivery.",
    graphic: "./heart_relief_cutout.png",
    stat1: "88.6%",
    stat1Label: "Arterial Sweep Index",
    stat2: "-18%",
    stat2Label: "Fasting LDL Reductions"
  },
  diabetes: {
    title: "Glucose <strong>Modulation</strong> 🩸",
    desc: "Sensitizing metabolic pathway receptors on cell walls. Calibrates baseline fasting blood glucose indices by accelerating receptor response to healthy <em>insulin binding</em>, preventing sugar spikes in blood plasma.",
    graphic: "./diabetes_cutout.png",
    stat1: "5.4 mmol/L",
    stat1Label: "Optimized Baseline",
    stat2: "92.8%",
    stat2Label: "Metabolic Response Ratio"
  },
  antiaging: {
    title: "Anti-Aging <strong>Assay</strong> 👩‍⚖️",
    desc: "Reversing chronological cellular damage through <em>SIRT-1 pathway activation</em>. Repairs and protects double-helix DNA strands from environmental stress and oxidative damage, preserving optimal youthful transcription.",
    graphic: "./anti_aging_full_head.png",
    stat1: "3.2x",
    stat1Label: "SIRT-1 Activity",
    stat2: "14 Years",
    stat2Label: "Biological Age Restoration"
  },
  longevity: {
    title: "Telomere <strong>Extension</strong> ♾️",
    desc: "Extending biological lifespan from the molecular level. Enhances active <em>telomerase enzymes</em> to defend chromosome caps from dividing, maintaining cell replication capabilities and biological youth.",
    graphic: "./longevity_elderly_walk.png",
    stat1: "74.8%",
    stat1Label: "Telomere Cap Defense",
    stat2: "+15.6%",
    stat2Label: "Lifespan Span Index"
  }
};

function initPillarsHub() {
  const buttons = document.querySelectorAll(".pillar-tab-btn");
  if (buttons.length === 0) return;

  const cardTitle = document.getElementById("pillar-title");
  const cardDesc = document.getElementById("pillar-desc");
  const cardGraphic = document.getElementById("pillar-graphic");
  const stat1Num = document.getElementById("pillar-stat1-num");
  const stat1Label = document.getElementById("pillar-stat1-label");
  const stat2Num = document.getElementById("pillar-stat2-num");
  const stat2Label = document.getElementById("pillar-stat2-label");

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      if (btn.classList.contains("active")) return;
      
      buttons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      const key = btn.dataset.pillar;
      sessionStorage.setItem('ltms_active_pillar', key);
      const data = pillarData[key];
      if (!data) return;

      const displayCard = document.querySelector(".pillar-display-card");
      if (displayCard) {
        displayCard.style.opacity = "0.15";
        displayCard.style.transform = "translateY(16px)";
        
        setTimeout(() => {
          if (cardTitle) cardTitle.innerHTML = data.title;
          if (cardDesc) cardDesc.innerHTML = data.desc;
          if (cardGraphic) {
            cardGraphic.src = data.graphic;
            cardGraphic.alt = data.title.replace(/<[^>]*>/g, ""); // Strip HTML tags
          }
          if (stat1Num) stat1Num.innerHTML = data.stat1;
          if (stat1Label) stat1Label.innerHTML = data.stat1Label;
          if (stat2Num) stat2Num.innerHTML = data.stat2;
          if (stat2Label) stat2Label.innerHTML = data.stat2Label;
          
          displayCard.style.opacity = "1";
          displayCard.style.transform = "translateY(0)";
        }, 350);
      }
    });
  });

  // Restore active tab state from sessionStorage (for fluid prototype presentation)
  const savedPillar = sessionStorage.getItem('ltms_active_pillar');
  if (savedPillar && pillarData[savedPillar]) {
    const activeBtn = document.querySelector(`.pillar-tab-btn[data-pillar="${savedPillar}"]`);
    if (activeBtn && !activeBtn.classList.contains("active")) {
      activeBtn.click();
    }
  }
}

/**
 * 6. 3D Rotating & Physically Flippable Testimonials Carousel
 */
function init3DCardCarousel() {
  const cards = document.querySelectorAll(".evidence-card-3d");
  const prevBtn = document.querySelector(".ev-nav-prev");
  const nextBtn = document.querySelector(".ev-nav-next");

  if (cards.length === 0) return;

  let activeIndex = 0;

  function updateCarousel3D() {
    cards.forEach((card, idx) => {
      // Remove rotation statuses but keep flips intact if they were flipped
      card.classList.remove("active-card", "left-card", "right-card");
      
      if (idx === activeIndex) {
        card.classList.add("active-card");
      } else if (idx === (activeIndex - 1 + cards.length) % cards.length) {
        card.classList.add("left-card");
        card.classList.remove("flipped"); // Unflip hidden cards
      } else if (idx === (activeIndex + 1) % cards.length) {
        card.classList.add("right-card");
        card.classList.remove("flipped"); // Unflip hidden cards
      }
    });
  }

  // Setup click transitions for active cards to FLIP
  cards.forEach(card => {
    card.addEventListener("click", (e) => {
      if (card.classList.contains("active-card")) {
        // Toggle flip on active card
        card.classList.toggle("flipped");
      } else if (card.classList.contains("left-card")) {
        activeIndex = (activeIndex - 1 + cards.length) % cards.length;
        updateCarousel3D();
      } else if (card.classList.contains("right-card")) {
        activeIndex = (activeIndex + 1) % cards.length;
        updateCarousel3D();
      }
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      activeIndex = (activeIndex - 1 + cards.length) % cards.length;
      updateCarousel3D();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      activeIndex = (activeIndex + 1) % cards.length;
      updateCarousel3D();
    });
  }

  // Initialize deck layout
  updateCarousel3D();
}

/**
 * 7. Premium Mouse-follow Parallax Tilt Transforms
 */
function init3DTiltEffect() {
  const cards = document.querySelectorAll(".premium-product-card, .pain-metric-card, .delivery-node, .lth9-diag");
  
  cards.forEach(card => {
    card.addEventListener("mousemove", (e) => {
      const rect = card.getBoundingClientRect();
      const cardWidth = rect.width;
      const cardHeight = rect.height;
      
      const mouseX = e.clientX - rect.left - (cardWidth / 2);
      const mouseY = e.clientY - rect.top - (cardHeight / 2);
      
      const maxRotation = 5; 
      const rotateX = -((mouseY / (cardHeight / 2)) * maxRotation).toFixed(2);
      const rotateY = ((mouseX / (cardWidth / 2)) * maxRotation).toFixed(2);
      
      card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-8px)`;
      
      // Dynamic shine gradient flare overlay
      const shineValX = ((e.clientX - rect.left) / cardWidth * 100).toFixed(2);
      const shineValY = ((e.clientY - rect.top) / cardHeight * 100).toFixed(2);
      card.style.backgroundImage = `radial-gradient(circle at ${shineValX}% ${shineValY}%, rgba(197, 168, 128, 0.05) 0%, transparent 60%), var(--glass-bg)`;
    });
    
    card.addEventListener("mouseleave", () => {
      card.style.transform = "rotateX(0deg) rotateY(0deg) translateY(0px)";
      card.style.backgroundImage = "";
    });
  });
}

/**
 * 8. Magnetic pull effects on primary buttons
 */
function initMagneticButtons() {
  const buttons = document.querySelectorAll(".cta-btn, .ev-nav-btn, .theme-toggle-btn");
  
  buttons.forEach(btn => {
    btn.addEventListener("mousemove", (e) => {
      const rect = btn.getBoundingClientRect();
      const btnWidth = rect.width;
      const btnHeight = rect.height;
      
      // Distance from button center
      const mouseX = e.clientX - rect.left - (btnWidth / 2);
      const mouseY = e.clientY - rect.top - (btnHeight / 2);
      
      // Pull strength factor
      const strength = 0.25;
      const pullX = mouseX * strength;
      const pullY = mouseY * strength;
      
      requestAnimationFrame(() => {
        btn.style.transform = `translate3d(${pullX}px, ${pullY}px, 0) scale(1.02)`;
      });
    });
    
    btn.addEventListener("mouseleave", () => {
      requestAnimationFrame(() => {
        btn.style.transform = "translate3d(0, 0, 0) scale(1)";
      });
    });
  });
}
